export interface InstanceAutocompleteOption {
  instanceId: string | null
  uuid: string
  statusLabel: string
  statusSeverity: string
  dateStarted: string
}

export interface SelectedInstance {
  instanceId: string | null
  instanceUuid: string
  valid: boolean
}

export const mapInstanceToOption = (
  instance: { instanceId: string | null; uuid: string; status: string; dateStarted: string },
  statusTagTypeMap: Partial<Record<string, string>>
): InstanceAutocompleteOption => ({
  instanceId: instance.instanceId,
  uuid: instance.uuid,
  statusLabel: instance.status,
  statusSeverity:
    statusTagTypeMap[instance.status] ?? statusTagTypeMap[instance.status?.toLowerCase()] ?? 'info',
  dateStarted: instance.dateStarted,
})
